<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title class="text-subtitle-1">
            Permisos por area
            <v-spacer></v-spacer>
            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( permisosFiltrados, 'PERMISOS_AREA')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>

          </v-card-title>
          <v-card-text>

            <v-row align="center">
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="filtroEstatus"
                  :items="estatusPermisos"
                  item-text="text"
                  item-value="value"
                  label="Estatus"
                  filled
                  dense
                  clearable
                  hide-details
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="2">
                <v-text-field
                  v-model="filtroFechaSolicitudIni"
                  label="Solicitud desde"
                  type="date"
                  filled
                  dense
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="2">
                <v-text-field
                  v-model="filtroFechaSolicitudFin"
                  label="Solicitud hasta"
                  type="date"
                  filled
                  dense
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="1">
                <v-btn
                  color="grey"
                  dark
                  small
                  tile
                  block
                  @click="limpiarFiltros"
                >
                  Limpiar
                </v-btn>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="permisosFiltrados"
              sort-by="calories"
              class="elevation-0"
              :search="search"
            >

              <template v-slot:item.fecha_inicio="{ item }">
                {{ fechaCorta(item.fecha_inicio) }}
              </template>

              <template v-slot:item.fecha_final="{ item }">
                {{ fechaCorta(item.fecha_final) }}
              </template>

              <template v-slot:item.grupos="{ item }">
                <span v-if="!item.grupos">—</span>
                <template v-else>
                  <v-chip
                    v-for="(grupo, idx) in gruposLista(item.grupos)"
                    :key="idx"
                    x-small
                    class="ma-1"
                  >
                    {{ grupo }}
                  </v-chip>
                </template>
              </template>

              <template v-slot:item.autorizo_rh="{ item }">
                <v-chip small v-if="!item.autorizo_rh && !item.autorizo_jefe">SIN REVISION</v-chip>
                <v-chip small v-else-if="item.autorizo_rh == 1" color="green" dark>ACEPTADO</v-chip>
                <v-chip small v-else-if="item.autorizo_rh == 2" color="red" dark>NO ACEPTADO</v-chip>
                <v-chip small v-else-if="item.autorizo_rh && !item.autorizo_jefe" color="orange" dark>EN REVISION</v-chip>
                <v-chip small v-else-if="!item.autorizo_rh && item.autorizo_jefe" color="orange" dark>EN REVISION</v-chip>
              </template>

              <template v-slot:item.autorizo_jefe="{ item }">
                <v-chip small v-if="!item.autorizo_jefe && !item.autorizo_rh">SIN REVISION</v-chip>
                <v-chip small v-else-if="item.autorizo_jefe == 1" color="green" dark>ACEPTADO</v-chip>
                <v-chip small v-else-if="item.autorizo_jefe == 2" color="red" dark>NO ACEPTADO</v-chip>
                <v-chip small v-else-if="item.autorizo_rh && !item.autorizo_jefe" color="orange" dark>EN REVISION</v-chip>
                <v-chip small v-else-if="!item.autorizo_rh && item.autorizo_jefe" color="orange" dark>EN REVISION</v-chip>
                <v-chip small v-else-if="item.autorizo_jefe && item.autorizo_rh" color="green" dark>ACEPTADO</v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn 
                  color="primary"
                  @click="editItem(item)"
                  tile
                  dark
                  x-small
                >
                  <v-icon
                    small
                  >
                    mdi-magnify
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <v-btn
                  color="primary"
                  @click="initialize"
                >
                  Reset
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialog"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h6">Folio: {{ editedItem.idsolicitud_permisos }}</span>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            dark
            rounded
            small
            icon
            @click="close"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="black--text" v-if="editedIndex >= 0">
          <span><b>Solicitante: </b> {{ editedItem.solicitante }}</span>
          <br/>
          <span><b>Rango días:  </b> {{ fechaCorta(editedItem.fecha_inicio) }} a {{ fechaCorta(editedItem.fecha_final) }} </span>
          <br/>
          <span><b>Motivo:</b> {{ editedItem.motivo }}</span>
          <br v-if="editedItem.grupos"/>
          <span v-if="editedItem.grupos"><b>Grupos: </b> {{ editedItem.grupos }}</span>
          <br v-if="esProgramadorProducto"/>
          <v-chip v-if="esProgramadorProducto" small color="blue" dark>Solo lectura</v-chip>
          <br/>
          <br/>
          <br/>

          <v-row v-if="getdatosUsuarioERPERP.iderp != 2268">
            <v-col cols="12" md="6">
              <span><b>Jefe Directo:</b> {{ editedItem.jefe }}</span>
              <br/>
              <v-chip v-if="editedItem.autorizo_jefe == 1"  color="green" dark small>Autorizó</v-chip>
              <v-chip v-else-if="editedItem.autorizo_jefe == 2" color="red"   dark small>Rechazó</v-chip>
              <v-chip v-else-if="esProgramadorProducto" color="grey" dark small>Pendiente</v-chip>
              <span v-else>
                <v-radio-group
                  v-model="autorizar"
                  row
                >
                  <v-radio
                    label="Autorizar"
                    :value="1"
                  ></v-radio>
                  <v-radio
                    label="Rechazar"
                    :value="2"
                  ></v-radio>
                </v-radio-group>
              </span>
              <v-textarea
                v-if="autorizar == 2"
                filled
                hide-details
                dense
                label="Motivo del rechazo"
                v-model="nota_rechazo"
              > 
              </v-textarea>
              <br/>
              <span v-if="editedItem.motivo_rechazo_jefe"> {{ editedItem.motivo_rechazo_jefe }}</span>
            </v-col>

            <v-col cols="12" md="6">
              <span><b>RH:</b> {{ editedItem.rh }}</span>
              <br/>
              <v-chip 
                v-if="editedItem.autorizo_rh == 1"  
                color="green" 
                dark 
                small
              >
                Autorizó
              </v-chip>
              
              <v-chip 
                v-else-if="editedItem.autorizo_rh == 2" 
                color="red"   
                dark 
                small
              >
                Rechazó
              </v-chip>
              
              <v-chip 
                v-else 
                color="grey"   
                dark 
                small
              >
                Pendiente
              </v-chip>
              <br/>
              <span v-if="editedItem.motivo_rechazo_rh"> {{ editedItem.motivo_rechazo_rh }}</span>
            </v-col>
          </v-row>
          <v-row v-if="editedItem.archivo_adjunto != 'null'">
            <v-col cols="12">
              <v-img :src="url + editedItem.archivo_adjunto"/>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            dark
            tile
            small
            @click="close"
          >
            <v-icon left small>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!esProgramadorProducto && ![1,2].includes(editedItem.autorizo_rh)"
            color="green"
            dark
            tile
            small
            @click="save"
          >
            <v-icon left small>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
import axios from 'axios';
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores  from '@/mixins/validarErrores'
  import funcionesExcel  from '@/mixins/funcionesExcel'
  import leerImagenes    from '@/mixins/leerImagenes'


  export default {

    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores, funcionesExcel, leerImagenes ],

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      headers: [
        { text: 'ID'              , value: 'idsolicitud_permisos', sortable: false },
        { text: 'Solicitante'     , value: 'solicitante'                           },
        { text: 'Fecha solicitud' , value: 'fecha_creacion'                        },
        { text: 'Inicio permiso'  , value: 'fecha_inicio'                          },
        { text: 'Fin permiso'     , value: 'fecha_final'                           },
        { text: 'Grupos'          , value: 'grupos'                                },
        { text: 'Autorizado RH'   , value: 'autorizo_rh'                           },
        { text: 'Autorizado JEFE' , value: 'autorizo_jefe'                         },
        { text: 'Actions'         , value: 'actions', sortable: false              },
      ],

      search:'',
      filtroEstatus: null,
      filtroFechaSolicitudIni: null,
      filtroFechaSolicitudFin: null,
      estatusPermisos: [
        { value: 'sin_revision', text: 'Sin revisión' },
        { value: 'en_revision', text: 'En revisión' },
        { value: 'aceptado', text: 'Aceptado' },
        { value: 'no_aceptado', text: 'No aceptado' },
      ],
      permisos: [],
      editedIndex: -1,
      editedItem: {
        idsolicitud_permisos: '',
        id_usuario: 0,
        idareas_ticket: 0,
        id_jefe_directo: 0,
        id_rh: null,
        autorizo_jefe: null,
        autorizo_rh: null,
        fecha_inicio:null,
        fecha_final: null,
        motivo: '',
        archivo_adjunto: null,
        motivo_rechazo_jefe:'',
        motivo_rechazo_rh:''
      },
      defaultItem: {
        idsolicitud_permisos: '',
        id_usuario: 0,
        idareas_ticket: 0,
        id_jefe_directo: 0,
        id_rh: null,
        autorizo_jefe: null,
        autorizo_rh: null,
        fecha_inicio:null,
        fecha_final: null,
        motivo: '',
        archivo_adjunto: null,
        motivo_rechazo_jefe:'',
        motivo_rechazo_rh:''
      },

      file: '',
      dragging: false,
      vistaPrevia: null,
      autorizar:null,
      nota_rechazo:'',
      url:''



    }),

    computed: {
      ...mapGetters('login', ['getdatosUsuarioERPERP']),
      esProgramadorProducto () {
        return Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.idpuesto) === 52
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
      permisosFiltrados () {
        let permisos = this.permisos

        if( this.filtroEstatus ){
          permisos = permisos.filter( item => this.estatusSolicitud( item ) === this.filtroEstatus )
        }

        if( this.filtroFechaSolicitudIni ){
          permisos = permisos.filter( item => {
            const fecha = this.fechaSolicitud( item )
            return fecha && fecha >= this.filtroFechaSolicitudIni
          })
        }

        if( this.filtroFechaSolicitudFin ){
          permisos = permisos.filter( item => {
            const fecha = this.fechaSolicitud( item )
            return fecha && fecha <= this.filtroFechaSolicitudFin
          })
        }

        return permisos
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.url = axios.defaults.baseURL + 'justificantes/'

      this.initialize()
    },

    methods: {
      initialize () {
        this.permisos = []
        this.cargar = true

        const payload = {
          id: this.getdatosUsuarioERPERP.iderp,
          idpuesto: this.getdatosUsuarioERPERP.idpuesto
        }

        return this.$http.post('permisos.area', payload ).then(response=>{
          this.permisos = response.data
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.permisos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.permisos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.permisos.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.autorizar = null
        this.nota_rechazo = ''
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      limpiarFiltros () {
        this.filtroEstatus = null
        this.filtroFechaSolicitudIni = null
        this.filtroFechaSolicitudFin = null
        this.search = ''
      },

      fechaSolicitud (item) {
        return item.fecha_creacion ? String(item.fecha_creacion).substr(0, 10) : ''
      },

      fechaCorta (valor) {
        if (!valor) return '—'
        return String(valor).substr(0, 10)
      },

      gruposLista (grupos) {
        if (!grupos) return []
        return String(grupos).split(',').map(g => g.trim()).filter(Boolean)
      },

      estatusSolicitud (item) {
        if( item.autorizo_rh == 2 || item.autorizo_jefe == 2 ) return 'no_aceptado'
        if( item.autorizo_rh == 1 && item.autorizo_jefe == 1 ) return 'aceptado'
        if( !item.autorizo_rh && !item.autorizo_jefe ) return 'sin_revision'
        return 'en_revision'
      },

      save () {
        // Guardar imagen primero y retornar lo demás
        this.cargar = true
        let formData = new FormData();
        //se crea el objeto y se le agrega como un apendice el archivo
        formData.append('idsolicitud_permisos'  ,this.editedItem.idsolicitud_permisos)
        formData.append('id_jefe_directo'       ,this.getdatosUsuarioERPERP.iderp)
        formData.append('autorizo_jefe'         ,this.autorizar)
        formData.append('motivo_rechazo_jefe'   ,this.nota_rechazo)

        return this.$http.post('permisos.aceptar.jefe', formData ).then(response=>{
          this.file = null
          this.initialize()
          this.validarSuccess( response.data.message )
          this.cargar = false
          this.close()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },
    },
  }
</script>
<style scoped>
  .dropZone {
    width: 80%;
    height: 150px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }
</style>